import { Component } from '@angular/core';

@Component({
  selector: 'app-hosting-faqs',
  templateUrl: './hosting-faqs.component.html',
  styleUrls: ['./hosting-faqs.component.css']
})
export class HostingFaqsComponent {
  navClass = 'nav-light';
    // Set Topbar Option
  Menuoption = 'hosting';
  Settingicon = true
  footerVariant = 'footer-ten';
}
